import { useDispatch, useSelector } from "react-redux"
import {
  useFetchWithBody,
  usePost,
} from "../../api/reactQueryCustomHooks"
import { apiRoute, CHALLAN_TYPE, decryptText, ENUM_BILL_TYPE, ENUM_CURRENCY_SETTING_VAL, ENUM_ENTRY_TYPE, ENUM_MOD_NAME, ENUM_MOD_PARAMETER, ENUM_PAGEACTION_TYPE, ENUM_STATUS, ENUM_TRADEOF_CODE, ENUM_TRADEOF_TYPE, getModValue, linksUrl, SALE_PUR_ENTRY_TYPE, URIEncrypt } from "../../constants/enum"
import {
  ErrorCard,
  LoadingCard,
  MainContainer,
  NextUITable,
} from "../../components"
import {
  Button,
  Modal,
  ModalBody,
  ModalContent,
  ModalHeader,
  useDisclosure,
} from "@heroui/react"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import {
  faEdit,
  faFileInvoice,
  faHexagonNodes,
  faPlus,
  faReceipt,
  faStamp,
  faTrash,
} from "@fortawesome/free-solid-svg-icons"

import {
  COLUMN_ALIGN_TYPE,
  COLUMN_TYPE,
  FOOTER_TYPE,
  ROW_ACTION_BTN_TYPE,
} from "../../components/NextUITable"
import { useNavigate, useParams } from "react-router-dom"
import { useEffect, useMemo, useState } from "react"
import { calculateTotal } from "../../Utility/utility"
import { toast } from "react-toastify"
import ConfirmBox from "../../components/ConfirmBox"
import { resetDetailParams, setDetailParams, setNewEntryMode } from "../../state/mixSlitEntrySlice"
//import { resetDetailParams, setDetailParams,  setNewEntryMode } from "../../state/mixSlitEntrySlice"

const MixSlitEntryMaster = () => {
  let disapatch = useDispatch()
  let navigate = useNavigate()
  const { compCode, isMultipleCompany, yearId, CurrencySetting } = useSelector((state) => state.company)
  let [itemToDelete, setItemToDelete] = useState("")
  const [itemToEdit, setItemToEdit] = useState("")
  const [pageActionType, setPageActionType] = useState("")
  const { mtrdtype, mptype } = useParams()
  const [entryLabel, setEntryLabel] = useState()
  const [selTradeOf, setSelTradeOf] = useState()
  const [selPktType, setSelPktType] = useState()
  const [naviCode, setnaviCode] = useState()


  //console.log(isNewEntry,detailParams)

  useEffect(() => {
    if (isMultipleCompany)
      navigate(linksUrl.dashboard.tradingDashboard)
    disapatch(resetDetailParams())

    const params = [URIEncrypt.Polish, URIEncrypt.Rough, URIEncrypt.Rejection]
    if (!params.includes(String(mtrdtype))
      || ![URIEncrypt.SinglePacket, URIEncrypt.Mix].includes(String(mptype))
    )
      navigate(linksUrl.dashboard.tradingDashboard)

    if (mtrdtype && mtrdtype != "" || mptype && mptype != "") {

      let t_trdtype = mtrdtype.toLowerCase()
      let t_tradeof = ''
      let t_entryLabel = ''
      let t_ptype = ''


      if (mptype == URIEncrypt.SinglePacket)
        t_ptype = 'SNG'
      else
        t_ptype = 'MIX'

      if (t_trdtype == URIEncrypt.Polish.toLowerCase()) {
        t_tradeof = ENUM_TRADEOF_CODE.Polish
        t_entryLabel = "Polish Diamond "
        setnaviCode(linksUrl.mixslitEntry.polishDiamond)
      }
      else if (t_trdtype == URIEncrypt.Rough.toLowerCase()) {
        t_tradeof = ENUM_TRADEOF_CODE.Rough
        t_entryLabel = "Rough Diamond "
        setnaviCode(linksUrl.mixslitEntry.roughDiamond)
      }

      setSelTradeOf(t_tradeof)
      setEntryLabel(t_entryLabel)
      setSelPktType(t_ptype)
      funFilterData(t_tradeof, t_ptype);
    }


  }, [mtrdtype, mptype])


  const {
    isError,
    isPending,
    data = [],
    mutate: filterData
  } = usePost({
    url: apiRoute.mixslitEntry.fetch,
    queryKey: "MixSlit Data List",

  })
  const funFilterData = (tradeof, pkttype) => {
    filterData({
      data: {
        compcode: compCode.join(","),
        tradeof: tradeof,
        pkttype: pkttype == 'SNG' ? pkttype : ''
      }
    })

  }


  const onSuccessDelete = (data) => {
    setItemToDelete("")
    if (data && data.length > 0) {
      if (data[0].ref == 1) {
        toast.error("Entry can't be delete as it locked", {
          "position": "top-center",
          "className": "toast-error",
        })
      }
      else {
        toast.success("deleted successfully", {
          position: "top-center"
        })
        funFilterData(selTradeOf, selPktType);
      }

    }

  }

  const { mutate: FndeleteNote } = usePost(
    {
      url: apiRoute.mixslitEntry.deleteEntry,
      query: "delete-note",
      onSuccessTasks: onSuccessDelete
    }
  )

  let totalPcs = useMemo(
    () =>
      calculateTotal({
        data: data,
        columnName: "TPcs",
      }),
    [data]
  )
  let totalBalWeight = useMemo(
    () =>
      calculateTotal({
        data: data,
        columnName: "BalWeight",
      }),
    [data]
  )
  let totalWeight = useMemo(
    () =>
      calculateTotal({
        data: data,
        columnName: "TWeight",
      }),
    [data]
  )
  let totalAmount = useMemo(
    () =>
      calculateTotal({
        data: data,
        columnName: "TAmount",
      }),
    [data]
  )

  let totalAmountD = useMemo(
    () =>
      calculateTotal({
        data: data,
        columnName: "TAmountD",
      }),
    [data]
  )

  const INITIAL_VISIBLE_COLUMNS = [
    "actions",
    "Vou_No",
    "TPcs",
    "TWeight",
    "BalWeight",
    //"TWeight",
    "TAmount",
    "TAmountD",
    "MDate",

  ]
  const [initialColumn, setInitialColumn] = useState(INITIAL_VISIBLE_COLUMNS)

  const exportColumns = [
    {
      name: "Vou NO",
      uid: "Vou_No",
    },
    {
      name: "PCS",
      uid: "TPcs",
    },
    {
      name: "Weight",
      uid: "TWeight",
    },
    {
      name: "Bal Weight",
      uid: "BalWeight",
    },
    {
      name: "Amount",
      uid: "TAmount",
    },
    {
      name: "Amount($)",
      uid: "TAmountD",
    },
    {
      name: "DATE",
      uid: "MDate",
      type: COLUMN_TYPE.date
    },
  ]
  const [exportCols, setExportCols] = useState(exportColumns)

  let downloadDataFooter = {
    Vou_No: "",
    TPcs: "Total:" + totalPcs,
    TWeight: "Total:0" + totalWeight,
    BalWeight: "Total:" + totalBalWeight,
    TAmount: "Total:" + totalAmount,
    TAmountD: "Total:" + totalAmountD,
    MDate: "",
  }

  const [exportFooter, setExportFooter] = useState(downloadDataFooter)

  useEffect(() => {
    if (CurrencySetting && CurrencySetting != "") {
      let AmtColumn = ""
      if (CurrencySetting == ENUM_CURRENCY_SETTING_VAL.RS)
        AmtColumn = "TAmountD"
      else if (CurrencySetting == ENUM_CURRENCY_SETTING_VAL.Dollar)
        AmtColumn = "TAmount"
      else
        setInitialColumn(INITIAL_VISIBLE_COLUMNS)

      if (AmtColumn != "") {
        const filterIniCol = initialColumn.filter(ele => ele != AmtColumn)
        const filterExpCol = exportColumns.filter((ele) => ele.uid != AmtColumn)
        //let footerCol = AmtColumn == 'NetAmtD' ? 'Amount$' : 'Amount'
        const filterExpFooter = Object.keys(downloadDataFooter).filter((ele) => ele != AmtColumn)
        setExportCols(filterExpCol)
        setInitialColumn(filterIniCol)
        setExportFooter(filterExpFooter)
      }
    }
  }, [CurrencySetting, data])
  if (isError) {
    return <ErrorCard />
  }

  if (isPending) {
    return <LoadingCard />
  }

  const columns = [
    {
      name: "Actions",
      uid: "actions",
      align: COLUMN_ALIGN_TYPE.center,
    },
    {
      name: "Vou NO",
      uid: "Vou_No",
      sortable: true,
      align: COLUMN_ALIGN_TYPE.center,
    },
    {
      name: "Pcs",
      uid: "TPcs",
      align: COLUMN_ALIGN_TYPE.center,
      sortable: true,
      type: COLUMN_TYPE.number,
      footer: {
        type: FOOTER_TYPE.text,
        label: "Total: ",
        value: totalPcs,
      },
    },
    {
      name: "Weight",
      uid: "TWeight",
      align: COLUMN_ALIGN_TYPE.center,
      sortable: true,
      type: COLUMN_TYPE.number,
      footer: {
        type: FOOTER_TYPE.text,
        label: "Total: ",
        value: totalWeight,
      },
    },
    {
      name: "Bal Weight",
      uid: "BalWeight",
      align: COLUMN_ALIGN_TYPE.center,
      sortable: true,
      type: COLUMN_TYPE.number,
      footer: {
        type: FOOTER_TYPE.text,
        label: "Total: ",
        value: totalBalWeight,
      },
    },
    {
      name: "Amount",
      uid: "TAmount",
      align: COLUMN_ALIGN_TYPE.center,
      sortable: true,
      type: COLUMN_TYPE.number,
      footer: {
        type: FOOTER_TYPE.text,
        label: "Total: ",
        value: totalAmount,
      },
    },
    {
      name: "Amount($)",
      uid: "TAmountD",
      align: COLUMN_ALIGN_TYPE.center,
      sortable: true,
      type: COLUMN_TYPE.number,
      footer: {
        type: FOOTER_TYPE.text,
        label: "Total: ",
        value: totalAmountD,
      },
    },
    {
      name: "DATE",
      uid: "MDate",
      type: COLUMN_TYPE.date,
      align: COLUMN_ALIGN_TYPE.center,
      sortable: true,
    },
  ]

  const handleConfirmBox = (data) => {
    if (data) {
      if (itemToDelete != "" & itemToDelete != null && Object.keys(itemToDelete).length > 0) {
        FndeleteNote({
          data: {
            transaction_id: itemToDelete.transaction_id,
            comp_code: itemToDelete.comp_code,
            pkt_type: itemToDelete.pkt_type,
            trade_of: selTradeOf,
            entry_type: itemToDelete.entry_type
          }
        })
      }
      else if (itemToEdit != "" & itemToEdit != null && Object.keys(itemToEdit).length > 0) {
        disapatch(setDetailParams(itemToEdit))
        disapatch(setNewEntryMode(false))
        if (itemToEdit.entry_type == 2 || itemToEdit.entry_type == 1) {
          navigate(naviCode + mtrdtype + "/" + URIEncrypt.Mix + linksUrl.mixEntry + linksUrl.mixslitEntry.createMixslitEntry)
        }
        if (itemToEdit.entry_type == 3 || itemToEdit.entry_type == 4)
          navigate(naviCode + mtrdtype + "/" + URIEncrypt.SinglePacket + linksUrl.mixslitEntry.createMixslitEntry)
      }
    }
    else {
      setItemToDelete("")
      setItemToEdit("")
      setPageActionType("")
    }

  }

  const rowActionBtn = [

    {
      icon: <FontAwesomeIcon color="#379906" icon={faEdit} />,
      onClick: (row) => {
        setItemToDelete("")
        setPageActionType(ENUM_PAGEACTION_TYPE.Edit)
        let obj = {
          comp_code: row.CompCode,
          transaction_id: row.TransactionId,
          trade_of: row.Trade_Of,
          status: row.BalWeight <= 0 ? ENUM_STATUS.Final : "",
          entry_type: row.Entry_Type

        }
        setItemToEdit(obj)

        // disapatch(setDetailParams(obj))
        // disapatch(setNewEntryMode(false))
        // if (row.Entry_Type == 2 || row.Entry_Type == 1) {
        //   navigate(naviCode + mtrdtype + "/" + URIEncrypt.Mix + linksUrl.mixEntry + linksUrl.mixslitEntry.createMixslitEntry)
        // }
        // if (row.Entry_Type == 3 || row.Entry_Type == 4)
        //   navigate(naviCode + mtrdtype + "/" + URIEncrypt.SinglePacket + linksUrl.mixslitEntry.createMixslitEntry)
      },
      type: ROW_ACTION_BTN_TYPE.link,
    },
    {
      icon: <FontAwesomeIcon color="#c40c18" icon={faTrash} />,
      onClick: (row) => {
        setItemToEdit("")
        setPageActionType(ENUM_PAGEACTION_TYPE.Delete)
        setItemToDelete({ transaction_id: row.TransactionId, comp_code: row.CompCode, pkt_type: row.PktType, entry_type: row.Entry_Type })
      },
      type: ROW_ACTION_BTN_TYPE.link,
    },

  ]

  const handleAddNew = () => {
    disapatch(resetDetailParams())
    if (selPktType == 'MIX')
      navigate(naviCode + mtrdtype + "/" + mptype + linksUrl.mixEntry + linksUrl.mixslitEntry.createMixslitEntry)
    else
      navigate(naviCode + mtrdtype + "/" + mptype + linksUrl.mixslitEntry.createMixslitEntry)

  }


  return (
    <div>
      {(itemToDelete || itemToEdit) && (
        <ConfirmBox
          handleConfirmBox={handleConfirmBox}
          actionType={pageActionType}
        />
      )}
      <MainContainer
        pageName={entryLabel + `Mix Slit - ${selPktType == 'SNG' ? "Single Packet" : selPktType}`}
        info={[]}
        breadcrumbs={[entryLabel, "Mix Slit", selPktType == 'SNG' ? "Single Packet" : selPktType]}
      >
        <div className="" style={{ textAlign: "right" }}>
          <Button
            size="sm"
            color="primary"
            startContent={<FontAwesomeIcon icon={faPlus} />}
            onPress={handleAddNew}
          >
            Add New
          </Button>
        </div>

        <NextUITable
          INITIAL_VISIBLE_COLUMNS={initialColumn}
          data={data}
          columns={columns}
          rowActionBtn={rowActionBtn}
          exportColumns={exportCols}
          downloadDataFooter={exportFooter}
          showAdvanceFilter={false}
          downloadFileName={entryLabel + "MixSlit-List"}
          id="TransactionId"
        ></NextUITable>
      </MainContainer>
    </div>
  )
}
export default MixSlitEntryMaster
